<template>

	<div
		@mouseover="autoRotate=false"
		@mouseleave="autoRotate=true"
		:class="[
			'Gallery',
			'is-' + activeLayout,
			'hasImageCount-' + images.length,
			'withRatio-' + ratio
			]">

		<div
			ref="scrollable"
			class="Gallery-wrapper">

			<a
				v-if="(activeLayout == 'carousel')"
				href="#"
				@click="setActiveIndex($event, activeIndex - 1)"
				class="Gallery-navigation-previous">

				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Previous Image</title><path fill-rule="evenodd" clip-rule="evenodd" d="M8.75926 5.34923C8.39983 4.9299 7.76854 4.88134 7.34921 5.24076L0.349209 11.2408C0.127563 11.4307 0 11.7081 0 12C0 12.2919 0.127563 12.5693 0.349209 12.7593L7.34921 18.7593C7.76854 19.1187 8.39983 19.0701 8.75926 18.6508C9.11868 18.2315 9.07012 17.6002 8.65079 17.2408L3.70326 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H3.70326L8.65079 6.75927C9.07012 6.39985 9.11868 5.76855 8.75926 5.34923Z" fill="#515762"></path></svg>
			</a>

			<div
				:class="[
					'Gallery-grid',
					'withCol-' + galleryColumns,
					]">

				<div
					v-for="(image, index) in images"
					:class="{ 'is-visible': (activeLayout != 'carousel' || activeIndex == index) }">

					<img
						:class="{ 'Gallery-image': true }"
						:src="image.url"
						v-bind:style="{ height: '100%', width: 'auto' }"
						data-pin="false"
						:alt="image.alt"
					/>

				</div>

			</div>

			<a
				v-if="(activeLayout == 'carousel')"
				href="#"
				@click="setActiveIndex($event, activeIndex + 1)"
				class="Gallery-navigation-next">

				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Next Image</title><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2407 5.34923C15.6002 4.9299 16.2315 4.88134 16.6508 5.24076L23.6508 11.2408C23.8724 11.4307 24 11.7081 24 12C24 12.2919 23.8724 12.5693 23.6508 12.7593L16.6508 18.7593C16.2315 19.1187 15.6002 19.0701 15.2407 18.6508C14.8813 18.2315 14.9299 17.6002 15.3492 17.2408L20.2967 13H1C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H20.2967L15.3492 6.75927C14.9299 6.39985 14.8813 5.76855 15.2407 5.34923Z" fill="#515762"></path></svg>
			</a>

		</div>

		<div
			v-if="showProgressBar"
			class="Gallery-progress">
			<div
				class="Gallery-progress-fill"
				v-bind:style="{ left: scrollProgress + '%' }"/>
		</div>

	</div>

</template>

<style></style>

<script>

export default {

	name: 'gallery',

	mixins: [],

	components: {},

	data() {

		return {
			scrollProgress: 0,
			activeIndex: 0,
			showProgressBar: true,
			galleryColumns: 1,
			autoRotate: true,
			rotateDelay: 3500,
			activeLayout: '',
		}

	},

	computed: {},

	props: {
		images: {
			type: Array,
			default: () => [],
		},
		ratio: {
			type: String,
			default: '1x1',
		},
		columns: {
			type: Number,
			default: 1,
		},
		layout: {
			type: String,
			default: 'carousel',
		},
	},

	methods: {
		setActiveIndex( event, index ) {
			if (event) {
				event.preventDefault()
			}

			let isBeforeStart = index < 0
			let isPastEnd = index > (this.images.length - 1)

			if ( isBeforeStart ) {
				index = (this.images.length - 1)
			}
			else if ( isPastEnd ) {
				index = 0
			}

			this.activeIndex = index
			this.carouselNavigation()
		},

		handleScroll( event ) {
			if (this.activeLayout != 'carousel') {

				let markerWidthPercent = 25
				let element = event.target
				let maxWidth = 100 - markerWidthPercent
				let progress = (element.scrollLeft / (element.scrollWidth - element.clientWidth) ) * maxWidth

				this.scrollProgress = progress
			}
		},

		handleResize( event ) {
			if (window.innerWidth < 902) {
				this.autoRotate = false
				this.activeLayout = 'horizontal'
				this.scrollProgress = 0;
			} else {
				this.autoRotate = true
				this.activeLayout = this.layout
			}

		},

		carouselNavigation() {
			if (this.layout == 'carousel') {
				let progress = (100 / this.images.length) * this.activeIndex
				this.scrollProgress = progress
			}
		},

		rotate() {
			if (this.autoRotate) {
				this.setActiveIndex(null, this.activeIndex += 1)
			}

			setTimeout(() => {
				this.rotate()
			}, this.rotateDelay);
		},
	},

	created() {
	},

	mounted() {
		this.activeLayout = this.layout

		if (this.images.length <= this.columns) {
			this.showProgressBar = false
		}

		if (this.layout != 'carousel') {
			this.galleryColumns = this.columns
		} else {
			if (this.images.length > 1) {
				setTimeout(() => {
					this.rotate()
				}, this.rotateDelay);
			}
		}

		window.addEventListener('resize', this.handleResize)
		this.$refs.scrollable.addEventListener('scroll', this.handleScroll)

		this.handleResize()
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize)
		this.$refs.scrollable.removeEventListener('scroll', this.handleScroll)
	},

}

</script>
